import { render } from "./EstadoInicial.vue?vue&type=template&id=6530c200&scoped=true&lang=pug"
import script from "./EstadoInicial.vue?vue&type=script&lang=js"
export * from "./EstadoInicial.vue?vue&type=script&lang=js"

import "./EstadoInicial.vue?vue&type=style&index=0&id=6530c200&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6530c200"],['__file',"src/common/SmartTable/EstadoInicial.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6530c200"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6530c200', __exports__)) {
    api.reload('6530c200', __exports__)
  }
  
  module.hot.accept("./EstadoInicial.vue?vue&type=template&id=6530c200&scoped=true&lang=pug", () => {
    api.rerender('6530c200', render)
  })

}


export default __exports__